import React from 'react';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Search, Filter, Download } from 'lucide-react';
const sampleSales = [{
  id: 'CHMB-20260519-0001',
  date: '১৯ মে ২০২৬, ১০:১৫ AM',
  qty: '২',
  price: '৳২০',
  total: '৳৪০',
  gateway: 'bKash',
  status: 'Paid',
  printed: 'Yes'
}, {
  id: 'CHMB-20260519-0002',
  date: '১৯ মে ২০২৬, ১০:২২ AM',
  qty: '৪',
  price: '৳২০',
  total: '৳৮০',
  gateway: 'Nagad',
  status: 'Paid',
  printed: 'Yes'
}, {
  id: 'CHMB-20260519-0003',
  date: '১৯ মে ২০২৬, ১০:৩৮ AM',
  qty: '১',
  price: '৳২০',
  total: '৳২০',
  gateway: 'bKash',
  status: 'Paid',
  printed: 'Yes'
}, {
  id: 'CHMB-20260519-0004',
  date: '১৯ মে ২০২৬, ১১:০৫ AM',
  qty: '৫',
  price: '৳২০',
  total: '৳১০০',
  gateway: 'Nagad',
  status: 'Paid',
  printed: 'Yes'
}, {
  id: 'CHMB-20260519-0005',
  date: '১৯ মে ২০২৬, ১১:২০ AM',
  qty: '৩',
  price: '৳২০',
  total: '৳৬০',
  gateway: 'bKash',
  status: 'Failed',
  printed: 'No'
}, {
  id: 'CHMB-20260519-0006',
  date: '১৯ মে ২০২৬, ১১:৪৫ AM',
  qty: '১০',
  price: '৳২০',
  total: '৳২০০',
  gateway: 'bKash',
  status: 'Paid',
  printed: 'Yes'
}, {
  id: 'CHMB-20260519-0007',
  date: '১৯ মে ২০২৬, ১২:১০ PM',
  qty: '২',
  price: '৳২০',
  total: '৳৪০',
  gateway: 'Nagad',
  status: 'Paid',
  printed: 'Yes'
}, {
  id: 'CHMB-20260519-0008',
  date: '১৯ মে ২০২৬, ১২:৩০ PM',
  qty: '১',
  price: '৳২০',
  total: '৳২০',
  gateway: 'bKash',
  status: 'Paid',
  printed: 'Reprint Required'
}, {
  id: 'CHMB-20260519-0009',
  date: '১৯ মে ২০২৬, ০১:০০ PM',
  qty: '৪',
  price: '৳২০',
  total: '৳৮০',
  gateway: 'Nagad',
  status: 'Pending',
  printed: 'No'
}, {
  id: 'CHMB-20260519-0010',
  date: '১৯ মে ২০২৬, ০১:২৫ PM',
  qty: '৫',
  price: '৳২০',
  total: '৳১০০',
  gateway: 'bKash',
  status: 'Paid',
  printed: 'Yes'
}];
export function TicketSales() {
  return <div className="space-y-6" data-id="element-360">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-361">
        <div data-id="element-362">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-363">টিকিট বিক্রয়</h1>
          <p className="text-slate-500" data-id="element-364">সকল বিক্রিত টিকিটের তালিকা</p>
        </div>
        <Button variant="outline" className="gap-2" data-id="element-365">
          <Download className="w-4 h-4" data-id="element-366" />
          এক্সপোর্ট
        </Button>
      </div>

      {/* Filters */}
      <div className="bg-white p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-wrap gap-4" data-id="element-367">
        <div className="flex-1 min-w-[200px]" data-id="element-368">
          <Input icon={<Search className="w-4 h-4" data-id="element-370" />} placeholder="টিকিট আইডি দিয়ে খুঁজুন..." className="h-10" data-id="element-369" />
        </div>
        <Input type="date" className="h-10 w-auto" data-id="element-371" />
        <select className="h-10 rounded-xl border border-slate-200 px-3 text-sm focus:ring-2 focus:ring-brand-coral outline-none" data-id="element-372">
          <option value="" data-id="element-373">সকল গেটওয়ে</option>
          <option value="bkash" data-id="element-374">bKash</option>
          <option value="nagad" data-id="element-375">Nagad</option>
        </select>
        <select className="h-10 rounded-xl border border-slate-200 px-3 text-sm focus:ring-2 focus:ring-brand-coral outline-none" data-id="element-376">
          <option value="" data-id="element-377">সকল স্ট্যাটাস</option>
          <option value="paid" data-id="element-378">Paid</option>
          <option value="failed" data-id="element-379">Failed</option>
          <option value="pending" data-id="element-380">Pending</option>
        </select>
      </div>

      {/* Table */}
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-381">
        <div className="overflow-x-auto" data-id="element-382">
          <table className="w-full text-sm text-left whitespace-nowrap" data-id="element-383">
            <thead className="text-xs text-slate-500 bg-slate-50 uppercase" data-id="element-384">
              <tr data-id="element-385">
                <th className="px-6 py-4 font-medium" data-id="element-386">Ticket ID</th>
                <th className="px-6 py-4 font-medium" data-id="element-387">Date & Time</th>
                <th className="px-6 py-4 font-medium text-center" data-id="element-388">Qty</th>
                <th className="px-6 py-4 font-medium text-right" data-id="element-389">Total</th>
                <th className="px-6 py-4 font-medium" data-id="element-390">Gateway</th>
                <th className="px-6 py-4 font-medium" data-id="element-391">Status</th>
                <th className="px-6 py-4 font-medium" data-id="element-392">Printed</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-393">
              {sampleSales.map((sale, i) => <tr key={i} className="hover:bg-slate-50" data-id="element-394">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-395">
                    {sale.id}
                  </td>
                  <td className="px-6 py-4 text-slate-500" data-id="element-396">{sale.date}</td>
                  <td className="px-6 py-4 text-center font-medium" data-id="element-397">
                    {sale.qty}
                  </td>
                  <td className="px-6 py-4 text-right font-medium text-slate-900" data-id="element-398">
                    {sale.total}
                  </td>
                  <td className="px-6 py-4" data-id="element-399">
                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium ${sale.gateway === 'bKash' ? 'bg-[#e2136e]/10 text-[#e2136e]' : 'bg-[#f7931e]/10 text-[#f7931e]'}`} data-id="element-400">
                      {sale.gateway}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-401">
                    <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-medium ${sale.status === 'Paid' ? 'bg-brand-green/10 text-brand-green' : sale.status === 'Failed' ? 'bg-destructive/10 text-destructive' : 'bg-amber-100 text-amber-700'}`} data-id="element-402">
                      {sale.status}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-403">
                    <span className={`text-xs ${sale.printed === 'Yes' ? 'text-brand-green' : sale.printed === 'No' ? 'text-slate-400' : 'text-amber-600 font-medium'}`} data-id="element-404">
                      {sale.printed}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="p-4 border-t border-slate-100 flex items-center justify-between text-sm text-slate-500" data-id="element-405">
          <span data-id="element-406">মোট ১০ টি রেকর্ড দেখাচ্ছে</span>
          <div className="flex gap-2" data-id="element-407">
            <Button variant="outline" size="sm" disabled data-id="element-408">
              পূর্ববর্তী
            </Button>
            <Button variant="outline" size="sm" disabled data-id="element-409">
              পরবর্তী
            </Button>
          </div>
        </div>
      </div>
    </div>;
}